// 用户信息
const userStore = {
  // 注意：不要在不同的、无命名空间的模块中定义两个相同的 getter， 会出错。
  // modules 模块开启 `命名空间`:通过添加 namespaced: true 的方式使其成为带命名空间的模块。
  // 当模块被注册后，它的所有 getter、action 及 mutation 都会自动根据模块注册的路径调整命名
  namespaced: true,
  state: () => ({
    // token
    userId: '',
    openId: '',
    // 用户id单独拿出来一下
    nickName: '',
    // 用户信息
    headimgurl: '',
    isAdmin:''
  }),
  // store 的计算属性
  getters: {
    // 获取颜色
    getInfoByKey: (state) => (key) => {
      return state[key]
    },
    getState:(state)=>(key)=>{
      return state[key]
    },
    getopenId:(state)=>()=>{
      return state.openId
    },
    getKeyIsHave: (state) => (keys) => {
      for (let i = 0; i < keys.length; i++) {
        let keyObj = state[keys[i]]
        if (keyObj!== {} && keyObj!== '' && keyObj!== null && keyObj!== undefined && keyObj!== -1 && keyObj!== [] ) {
          return true
        } else {
          return false
        }
      }
    }
  },
  // 更改 Vuex 的 store 中的状态的唯一方法是提交 mutation更改 Vuex 的 store 中的状态的唯一方法是提交 mutation
  mutations: {
    updateALLInfo(state, payload) {
      if (payload) {
        Object.keys(payload).forEach(key => {
          state[key] = payload[key]
        })
      }
    },
    setState(state, payload){
      if(payload){
        Object.keys(payload).forEach(key => {
          state[key] = payload[key]
        })
      }
    },
    logout(state) {
      state.zkr_campaign_token = ''
      state.isLogin = false
    }
  },
  actions: {
    changeUserInfo ({ commit }, data) {
      commit('updateALLInfo', data)
    },
    setStateActions({commit}, data){
      commit('setState', data)
    },
    logout({commit}) {
      commit('logout')
    }
  }

}

export default userStore
